(function(){
  // Diaporamas (hero)
  document.querySelectorAll('[data-slideshow]').forEach(function(sw){
    var slides = sw.querySelectorAll('.hero__slide');
    if(slides.length < 2) return;
    var delay = parseInt(sw.getAttribute('data-slideshow'), 10) || 5000;
    var i = 0;
    setInterval(function(){
      slides[i].classList.remove('is-active');
      i = (i+1) % slides.length;
      slides[i].classList.add('is-active');
    }, delay);
  });

  // Sliders horizontaux
  document.querySelectorAll('[data-slider]').forEach(function(wrap){
    var track = wrap.querySelector('.slider__track');
    if(!track) return;
    var prev = wrap.querySelector('[data-prev]');
    var next = wrap.querySelector('[data-next]');
    function step(){
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 20 : 300;
    }
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left: -step(), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); });
  });

  // Menu mobile
  var burger = document.querySelector('[data-burger]');
  var menu = document.querySelector('[data-mobile-menu]');
  if(burger && menu){
    burger.addEventListener('click', function(){
      var open = menu.classList.toggle('is-open');
      burger.classList.toggle('is-open', open);
      document.body.classList.toggle('menu-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        menu.classList.remove('is-open');
        burger.classList.remove('is-open');
        document.body.classList.remove('menu-open');
      });
    });
  }

  // Ombre du header
  var header = document.querySelector('.site-header');
  if(header){
    window.addEventListener('scroll', function(){
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, {passive:true});
  }

  // Formulaire liste d'attente : champs additionnels dans la note
  document.querySelectorAll('[data-wl-form]').forEach(function(wlForm){
    wlForm.addEventListener('submit', function(){
      var civ = wlForm.querySelector('[data-wl-civilite]');
      var wa = wlForm.querySelector('[data-wl-whatsapp]');
      var note = wlForm.querySelector('[data-wl-note]');
      if(note){
        var parts = [];
        if(civ && civ.value) parts.push('Civilité : ' + civ.value);
        if(wa && wa.value) parts.push('WhatsApp : ' + wa.value);
        note.value = parts.join(' | ');
      }
    });
  });

  // Apparition au scroll
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, {threshold: 0.12});
    document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function(el){ el.classList.add('is-visible'); });
  }
})();
